import deMain from "./locale/de_DE.json";
import enMain from "./locale/en_GB.json";
import esMain from "./locale/es_ES.json";
import frMain from "./locale/fr_FR.json";
import itMain from "./locale/it_IT.json";
import nlMain from "./locale/nl_NL.json";
import plMain from "./locale/pl_PL.json";
import ptMain from "./locale/pt_PT.json";
import zhMain from "./locale/zh_CN.json";
import deCities from "./locale/cities/de_DE.json";
import enCities from "./locale/cities/en_GB.json";
import esCities from "./locale/cities/es_ES.json";
import frCities from "./locale/cities/fr_FR.json";
import itCities from "./locale/cities/it_IT.json";
import nlCities from "./locale/cities/nl_NL.json";
import plCities from "./locale/cities/pl_PL.json";
import ptCities from "./locale/cities/pt_PT.json";
import zhCities from "./locale/cities/zh_CN.json";
import deCountries from "./locale/countries/de_DE.json";
import enCountries from "./locale/countries/en_GB.json";
import esCountries from "./locale/countries/es_ES.json";
import frCountries from "./locale/countries/fr_FR.json";
import itCountries from "./locale/countries/it_IT.json";
import nlCountries from "./locale/countries/nl_NL.json";
import plCountries from "./locale/countries/pl_PL.json";
import ptCountries from "./locale/countries/pt_PT.json";
import zhCountries from "./locale/countries/zh_CN.json";
import deTerms from "./locale/terms/de_DE.json";
import enTerms from "./locale/terms/en_GB.json";
import esTerms from "./locale/terms/es_ES.json";
import frTerms from "./locale/terms/fr_FR.json";
import itTerms from "./locale/terms/it_IT.json";
import nlTerms from "./locale/terms/nl_NL.json";
import plTerms from "./locale/terms/pl_PL.json";
import ptTerms from "./locale/terms/pt_PT.json";
import zhTerms from "./locale/terms/zh_CN.json";

export const localeMapping = {
  'de': 'de_DE',
  'en': 'en_GB',
  'es': 'es_ES',
  'fr': 'fr_FR',
  'it': 'it_IT',
  'nl': 'nl_NL',
  'pl': 'pl_PL',
  'pt': 'pt_PT',
  'zh': 'zh_CN'
};
const defaultLocale = 'en';
const uniLocaleCode = (locale) => {
  const domain = process.env.HOSTNAME.split('.').slice(1).join('.');

  return `uniLocaleCode=${localeMapping[locale]};domain=.${domain};path=/`;
};

export const handleCookieLocale = (locale) => {
  if (typeof document === 'undefined') {
    return;
  }

  if (locale !== defaultLocale) {
    return document.cookie = uniLocaleCode(locale);
  }

  const uniLocaleCodeQuery = document.cookie.replace(
    /(?:(?:^|.*;\s*)uniLocaleCode\s*=\s*([^;]*).*$)|^.*$/,
    "$1"
  );
  if (uniLocaleCodeQuery && uniLocaleCodeQuery !== localeMapping[defaultLocale]) {
    return changeLanguage(Object.keys(localeMapping).find(
      key => localeMapping[key] === uniLocaleCodeQuery
    ));
  }

  document.cookie = uniLocaleCode(locale);
};

export const changeLanguage = (locale, isDefault = false) => {
  if (isDefault) {
    document.cookie = uniLocaleCode(locale);
    locale = '';
  }

  const { pathname } = window.location;
  if (pathname === '/') {
    return window.location.href = locale;
  }

  const pathWithoutLang = pathname
    .split('/')
    .filter((element) => element.length !== 2)
    .join('/');

  if (!pathWithoutLang && !locale) {
    return window.location.href = '/';
  }

  if (locale) {
    return window.location.href = `/${locale}${pathWithoutLang}`;
  }

  window.location.href = pathWithoutLang;
};

export const translations = {
  de: {...deMain, ...deCities, ...deCountries, ...deTerms},
  en: {...enMain, ...enCities, ...enCountries, ...enTerms},
  es: {...esMain, ...esCities, ...esCountries, ...esTerms},
  fr: {...frMain, ...frCities, ...frCountries, ...frTerms},
  it: {...itMain, ...itCities, ...itCountries, ...itTerms},
  nl: {...nlMain, ...nlCities, ...nlCountries, ...nlTerms},
  pl: {...plMain, ...plCities, ...plCountries, ...plTerms},
  pt: {...ptMain, ...ptCities, ...ptCountries, ...ptTerms},
  zh: {...zhMain, ...zhCities, ...zhCountries, ...zhTerms}
};
